import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Label } from 'reactstrap';
import _ from "lodash";
import './SigningProgressModal.css';
import { Progress } from 'reactstrap';

class SigningProgressModal extends Component {
    render() {
        return (
            <Modal isOpen={this.props.isOpen && this.props.startSigning}>
                <ModalBody>
                    <Label>
                        <h5 className="text-center">{_.get(this.props.translation, 'bulk_jobs_list.signing_process_label')}</h5>
                        <h6>{_.get(this.props.translation, 'bulk_jobs_list.dont_close_tab_label')}</h6>
                        <div className="text-center">{this.props.signed}/{this.props.amount}</div>
                        <Progress animated color="primary" max={this.props.amount} value={this.props.signed}></Progress>
                    </Label>
                </ModalBody>
            </Modal>
        );
    }
}

SigningProgressModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    amount: PropTypes.number,
    signed: PropTypes.number,
    startSigning: PropTypes.bool.isRequired
};

export default SigningProgressModal;



// WEBPACK FOOTER //
// ./src/components/commonComponents/bulkDropZone/signingProgressModal/SigningProgressModal.js